import React from 'react';
import { DashboardOutstandingByPOCPivotMode } from '../../../../../constants/DashboardOutstandingByPOCPivotMode';
import { DashboardOutstandingByPOCPivotModeToggleButton } from './components/DashboardOutstandingByPOCPivotToggleButton';

export const Toolbar: React.FC<{
    pivotMode: DashboardOutstandingByPOCPivotMode;
    set_pivotMode: (mode: DashboardOutstandingByPOCPivotMode) => void;
}> = ({ pivotMode, set_pivotMode }) => {
    return (
        <div className='mode-bar'>
            <div className='mode-item'>
                Outstanding by POC
                <span className='toggle-wrapper'>
                    <DashboardOutstandingByPOCPivotModeToggleButton
                        pivotMode={pivotMode}
                        set_pivotMode={set_pivotMode}
                    />
                </span>
            </div>
        </div>
    );
};
